import VueClipboards from 'vue-clipboards'

export default async ({ Vue }) => {
  Vue.use(VueClipboards)
}
